"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
var _Folders = _interopRequireDefault(require("../Folders"));
var _CreateNewFolder = _interopRequireDefault(require("../CreateNewFolder"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ActionsModal = function ActionsModal(_ref) {
  var activeActionId = _ref.activeActionId,
    closeModal = _ref.closeModal,
    userSession = _ref.userSession,
    onActionClick = _ref.onActionClick,
    itemBrowserState = _ref.itemBrowserState,
    getUserFolders = _ref.getUserFolders,
    items = _ref.items,
    queryResults = _ref.queryResults,
    modalOpen = _ref.modalOpen;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    createFolderActive = _useState2[0],
    setCreateFolderActive = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedFolderId = _useState4[0],
    setSelectedFolder = _useState4[1];
  var title = activeActionId === "move" ? "Move Item" : activeActionId === "share" ? "Share" : activeActionId === "delete" ? "Delete" : "";
  var onFolderItemClick = function onFolderItemClick(id) {
    setSelectedFolder(id);
  };
  var createNewFolder = /*#__PURE__*/_react.default.createElement(_CreateNewFolder.default, {
    createFolderActive: createFolderActive,
    userSession: userSession,
    getUserFolders: getUserFolders,
    setCreateFolderActive: setCreateFolderActive,
    items: items,
    queryResults: queryResults
  });
  var getModalContent = function getModalContent() {
    switch (activeActionId) {
      case "move":
        return /*#__PURE__*/_react.default.createElement(_Folders.default, {
          folders: itemBrowserState === null || itemBrowserState === void 0 ? void 0 : itemBrowserState.folders,
          userSession: userSession,
          createFolderActive: createFolderActive,
          setCreateFolderActive: setCreateFolderActive,
          getUserFolders: getUserFolders,
          selectedFolderId: selectedFolderId,
          onFolderItemClick: onFolderItemClick,
          createNewFolder: createNewFolder,
          marginBottom: true,
          queryResults: queryResults
        });
      case "share":
        return "ArcgisShare Coming Soon...";
      case "delete":
        return "Are you sure you want to delete selected ".concat((items === null || items === void 0 ? void 0 : items.length) === 1 ? "item" : "items", "?");
      default:
        return "";
    }
  };
  var handleActionClick = function handleActionClick() {
    switch (activeActionId) {
      case "move":
        if (selectedFolderId) {
          onActionClick({
            selectedFolderId: selectedFolderId
          });
          setSelectedFolder(null);
        }
        break;
      case "share":
        onActionClick({});
        break;
      case "delete":
        onActionClick({});
        break;
      default:
        onActionClick({});
    }
  };
  var handleCloseModal = function handleCloseModal() {
    setSelectedFolder(null);
    closeModal();
  };
  var actionButton = /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
    key: activeActionId || "save",
    slot: "primary",
    width: "full",
    color: activeActionId === "delete" ? "red" : "blue",
    onClick: handleActionClick
    // Button is temporarily disabled for sharing, until sharing functionality is built out
    ,
    disabled: activeActionId === "share" || undefined
  }, activeActionId === "delete" ? "Delete" : "Save");
  var cancelButton = /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
    key: "cancel",
    appearance: "outline",
    onClick: handleCloseModal,
    slot: "secondary",
    width: "full"
  }, "Cancel");
  return /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteModal, {
    active: modalOpen || undefined,
    onCalciteModalClose: handleCloseModal
  }, /*#__PURE__*/_react.default.createElement("div", {
    slot: "header"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    slot: "content"
  }, getModalContent()), actionButton, cancelButton);
};
var _default = ActionsModal;
exports.default = _default;